import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconVodafoneLogoWhite from "../media/icons/vf-logo-white.png"
import {SpacerRow} from "./SpacerRow";


class SideBarMeinVodafone extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let content;
        content=<Row>
            <Col xs={12}>
                <SpacerRow/>
                <Row>
                    <Col xs={2}>
                        <img src={iconVodafoneLogoWhite} style={{height:"50px",width:"50px",marginLeft:"0px"}} alt={"white vodafone logo"} />
                    </Col>
                    <Col xs={10}>
                        <p className={"text-side-bar-regular"} style={{height:"28px", marginTop:"8px", color:"white"}}>
                            {i18n.t(this.props.mainText, this.props)}
                        </p>
                    </Col>
                </Row>
                <Row style={{marginTop:"16px"}}>
                    <Col xs={12}>
                        <p className={"text-bottom-bar-subtitle-vodafone-desktop"}>{i18n.t(this.props.subText, this.props)}</p>
                    </Col>
                </Row>
            </Col>
        </Row>;



        return <div>
            {content}
        </div>
    }
}

export default translate("translations")(SideBarMeinVodafone);